import IndexedDBService from '@/helpers/IndexedDBService'

const indexedDBPlugin = store => {
  store.indexedDB = IndexedDBService
}

export default indexedDBPlugin
